export const DEAL_STATUS = ['Not Displaying', 'Staking', 'Offering', 'Delivering', 'Claiming', 'Closed']